module.exports = __webpack_public_path__ + "images/emoji/u7121.a0cb8022fc84d40fc49e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/u7121.png
// module id = WDVG
// module chunks = 14